import { render, staticRenderFns } from "./infoPoint_list.vue?vue&type=template&id=478d920e&scoped=true&"
import script from "./infoPoint_list.vue?vue&type=script&lang=js&"
export * from "./infoPoint_list.vue?vue&type=script&lang=js&"
import style0 from "./infoPoint_list.vue?vue&type=style&index=0&id=478d920e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d920e",
  null
  
)

export default component.exports